import { useAttachmentUrl } from '../api/useAttachmentUrl';

interface AttachmentImageProps {
  storagePath: string;
  alt?: string;
  maxWidth?: number;
}

export function AttachmentImage({
  storagePath,
  alt = 'attachment',
  maxWidth = 320,
}: AttachmentImageProps) {
  const { url, loading } = useAttachmentUrl(storagePath);

  if (loading || !url) {
    return (
      <div
        style={{
          width: maxWidth,
          height: maxWidth * 0.6,
          background: '#f0f0f0',
          borderRadius: 8,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          color: '#999',
          fontSize: 12,
        }}
      >
        {loading ? 'Loading…' : 'Image unavailable'}
      </div>
    );
  }

  return (
    <a href={url} target="_blank" rel="noopener noreferrer">
      <img
        src={url}
        alt={alt}
        style={{
          maxWidth,
          maxHeight: maxWidth,
          borderRadius: 8,
          display: 'block',
        }}
      />
    </a>
  );
}
